import { cva } from '@/styled-system/css';

export const progressStepperIconRecipe = cva({
  base: {
    display: 'flex',
    width: 'ProgressMeter.Node.icon.default',
    height: 'ProgressMeter.Node.icon.default',
  },
  variants: {
    tone: {
      complete: {
        fill: 'ProgressMeter.Node.complete.icon',
        width: 'ProgressMeter.Node.icon.complete',
        height: 'ProgressMeter.Node.icon.complete',
      },
      incomplete: {
        fill: 'ProgressMeter.Node.incomplete.icon',
        width: 'ProgressMeter.Node.icon.incomplete',
        height: 'ProgressMeter.Node.icon.incomplete',
      },
      critical: {
        fill: 'ProgressMeter.Node.error.bg',
      },
      warning: {
        fill: 'ProgressMeter.Node.warning.bg',
      },
      notStarted: {},
      none: {},
    },
    active: {
      true: {
        fill: 'ProgressMeter.Node.complete.bg',
      },
      false: {},
    },
  },
});
